export default function fixCookieNoticeAccessibility() {
    let cn = document.querySelector('#cookie-notice');
    cn.removeAttribute('role');
    cn.removeAttribute('aria-label');

    let closeButton = document.querySelector('#cn-close-notice');
    closeButton.setAttribute('tabindex', '0');
    closeButton.setAttribute('role', 'button');
}